import { ApiPostRequestParams, ApiService, ApiServiceGetResponse } from '@services';
import { CreateItemOrder, getStatusOrder, StoreItem } from '@store';


export const getStoreItemsApi = async (): Promise<
  ApiServiceGetResponse<StoreItem[]>
> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/store`,
  })

  return { ok, data: data || null }
}

export const getCreateItemOrderApi = async (
  itemId: string,
  currency: string,
  quantity?: number
): Promise<ApiServiceGetResponse<CreateItemOrder>> => {
  const queryParams = new URLSearchParams()
  if (quantity) {
    queryParams.set('quantity', quantity.toString())
  }
  if (currency) {
    queryParams.set('currency', currency)
  }
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/store/${itemId}?${queryParams.toString()}`,
  })

  return { ok, data: data || null }
}

export const getOrderApi = async (
  orderId: string
): Promise<ApiServiceGetResponse<getStatusOrder>> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/store/order/${orderId}`,
  })

  return { ok, data: data || null }
}

export const getHintInvoiceApi = async (
  hintId: number
): Promise<ApiServiceGetResponse<{ invoice_url: string }>> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/store/hint/${hintId}`,
  })
  return { ok, data: data || null }
}

export const donationApi = async (
  amount: number,
  currency: 'TON' | 'XTR'
): Promise<ApiServiceGetResponse<CreateItemOrder>> => {
  const queryParams = new URLSearchParams()
  queryParams.set('amount', amount.toString())
  queryParams.set('currency', currency)

  const request: ApiPostRequestParams = {
    endpoint: `/api/v1/store/donation?${queryParams.toString()}`,
  }
  const { ok, data } = await ApiService.post(request)
  return { ok, data: data || null }
}
